import React, { Component } from 'react'
import Icon from './Icon'

class Expert extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg viewBox='0 0 24 24'>
          <g id='icons' stroke='none' strokeWidth='1' fillRule='evenodd'>
            <g transform='translate(-925.000000, -357.000000)' id='expert'>
              <path d='M933,365 C935.21,365 937,363.21 937,361 C937,358.79 935.21,357 933,357 C930.79,357 929,358.79 929,361 C929,363.21 930.79,365 933,365 L933,365 Z M933,367 C930.33,367 925,368.34 925,371 L925,373 L941,373 L941,371 C941,368.34 935.67,367 933,367 L933,367 Z' />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Expert
